import { aggreFieldAs } from '@/models/GenerateCondit/Interrelated';
import PublicAggCaculate from '@/models/GenerateCondit/PublicAggCaculate';
import GenerateCondit, { Bound, Condit } from '@/models/GenerateCondit';
import { getData } from '@/components/report/service';
import { BaseQuery3 } from '@/utils';
import { formatDate, getToDay } from '@/utils/date';
import moment from 'moment';
import RouteEntity from '@/Entity/RouteEntity';

// 计算库存向前推的天数
const stockDiffDay = -3

const [startDate, endDate] = getToDay()
const params = {
  orderKey: '',
  orderValue: '',

  startDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
  endDate: endDate.format('YYYY-MM-DD HH:mm:ss'),

  startDateCurrent: '',
  endDateCurrent: '',

  dataTableName: '',
  querDate: [
    { key: "scanSite", value: "萧山分拨中心" },
    { key: "nextSite", value: "上海分拨中心" }
  ],
  aggreField: [
    'ticket',
    'piece',
    'calcWeight',
    'goodsWeight',
    'goodsVolume',
  ],
  groupByField: ["waybillNo", "destinationCenter"],

  stockSeach: false
};
export default {
  namespace: 'centerinfogroupsummary',
  state: {
    searchParams: { ...params },

    dataList: [],
  },

  effects: {
    *getData(_, { put, select, call }) {
      const { searchParams } = yield select(({ centerinfogroupsummary }) => centerinfogroupsummary);
      const {
        orderKey,
        orderValue,
        startDate,
        endDate,
        startDateCurrent,
        endDateCurrent,
        dataTableName,
        querDate,
        aggreField,
        groupByField,
      } = searchParams

      const andFilters = querDate.filter(m => !!m.key)
      if (orderKey) {
        andFilters.push({ key: orderKey, value: orderValue })
      }

      const query = {
        simpleGranularity: 'all',
        dataSource: dataTableName,
        dimensions: groupByField,
        startDate: startDate,
        endDate: endDate,
        aggregators: aggreField.map(aggImte => aggreFieldAs[aggImte]),
        andFilters,
        boundFilters: (startDateCurrent && endDateCurrent) ? [
          {
            "dimension": "currentSystemTime",
            "lowerValue": formatDate(startDateCurrent),
            "upperValue": formatDate(endDateCurrent),
            "lowerEq": false,
            "upperEq": false
          }
        ] : undefined,
      }

      const data = yield call(getData, query)
      yield put({ type: 'updateState', payload: { dataList: data } })
    },
    *getStockData(_, { put, select, call }) {
      const { searchParams } = yield select(({ centerinfogroupsummary }) => centerinfogroupsummary);
      const {
        orderKey,
        orderValue,
        startDate,
        endDate,
        startDateCurrent,
        endDateCurrent,
        dataTableName,
        querDate,
        aggreField,
        groupByField,
      } = searchParams

      const andFilters = querDate.filter(m => !!m.key)
      if (orderKey) {
        andFilters.push({ key: orderKey, value: orderValue })
      }

      const startDates_stock = moment(startDate).add(stockDiffDay, 'days').format('YYYY-MM-DD HH:mm:ss')
      const endtDates_stock = moment(endDate).format('YYYY-MM-DD HH:mm:ss')

      const lowerValue = formatDate(startDateCurrent)
      const upperValue = formatDate(endDateCurrent)
      const currentSystemTime = (lowerValue && upperValue) ?
        {
          "dimension": "currentSystemTime",
          "lowerValue": lowerValue,
          "upperValue": upperValue,
          "lowerEq": false,
          "upperEq": false
        } : undefined
      const unloadQuery = {
        simpleGranularity: 'all',
        dataSource: dataTableName,
        dimensions: groupByField,
        startDate: startDates_stock,
        endDate: endtDates_stock,
        aggregators: BaseQuery3(),
        andFilters: [...andFilters, { key: 'scanType', value: '分拨卸车' }],
        boundFilters: currentSystemTime ? [currentSystemTime] : undefined,
      }
      const loadBoundFilters = [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(stockDiffDay, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        },
      ]
      if (currentSystemTime) {
        loadBoundFilters.push(currentSystemTime)
      }
      const loadQuery = {
        simpleGranularity: 'all',
        dataSource: dataTableName,
        dimensions: groupByField,
        startDate: startDates_stock,
        endDate: endtDates_stock,
        aggregators: BaseQuery3(),
        andFilters: [...andFilters, { key: 'scanType', value: '分拨装车' }],
        boundFilters: loadBoundFilters,
      }

      const unload = yield call(getData, unloadQuery)
      const load = yield call(getData, loadQuery)

      let data = unload.map(item => {
        const loadfind = load.find(m => {
          let finds = groupByField.length > 0             // 其实一定有分组，不然代码不会走到这里就报错了
          groupByField.filter(field => {                  // 和分组各个字段匹配，需要所有字段匹配成功
            finds = finds && (m[field] === item[field])
            return !finds
          })
          return finds
        })
        const temp = {}
        // 拼接分组字段，卸车为准
        groupByField.forEach(gbfield => {
          temp[gbfield] = item[gbfield]
        })

        // 卸车+装车库存
        aggreField.forEach(sltfield => {
          temp[sltfield] = item[sltfield]
        })
        if (loadfind) {
          aggreField.forEach(gbfield => {
            temp[gbfield] = (item[gbfield] || 0) + (loadfind[gbfield] || 0)
          })
        }
        return temp
      }) || []
      yield put({ type: 'updateState', payload: { dataList: data } })
    },
    *getStockDatas(_, { put, select, call }) {
      const { searchParams } = yield select(({ centerinfogroupsummary }) => centerinfogroupsummary);
      const {
        orderKey,
        orderValue,
        startDate,
        endDate,
        startDateCurrent,
        endDateCurrent,
        dataTableName,
        querDate,
        aggreField,
        groupByField,
      } = searchParams

      const condit = new Condit(
        dataTableName, groupByField,
        aggreField.map(aggImte => aggreFieldAs[aggImte]),
        startDate, endDate,
      )
      const gc = new GenerateCondit(condit)
      const route = new RouteEntity()
      querDate.forEach(m => {
        if (m => !!m.key)
          route[m.key] = m.value
      });
      if (orderKey)
        route[orderKey] = orderValue

      if (startDateCurrent && endDateCurrent) {
        const currentBound = new Bound(
          "currentSystemTime",
          moment(startDateCurrent).format("YYYY-MM-DD"),
          moment(endDateCurrent).format("YYYY-MM-DD"),
        )
        gc.pushBoundFilters(currentBound)
      }
      // route.productType = ['定时达', '安心达']
      // route.preSite = { notValue: ['昆山分拨中心', '杭州分拨中心'] }
      // gc.pushBoundFilters(new Bound(
      //   'unloadAggregateTime',
      //   moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
      //   moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
      //   false, false
      // ))
      // const conf = gc.converCondit(route)
      // console.log(conf.toSQL())
      const pubAgg = new PublicAggCaculate(gc)
      const storeData = yield pubAgg.getStockData(route, -3)
      yield put({ type: 'updateState', payload: { dataList: storeData } })
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    searchParamsUpdate(state, { payload }) {
      const searchParams = { ...state.searchParams, ...payload };
      return { ...state, searchParams };
    },
    resetSearchParam(state) {
      return { ...state, searchParams: { ...params } };
    },
  },
};
